<template lang="pug">
portal(
  v-if="hasAccess && welcomeComponent"
  :to="`${constants.DIALOG_PORTAL_KEY}.content`"
  v-slot="{ close }"
)
  component(
    :is="welcomeComponent"
    @close="close"
    @hide-next-time="onHideNextTime"
  ).text-start
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MemberWelcome from './roles/MemberWelcome.vue';
import OperatorWelcome from './roles/OperatorWelcome.vue';
import DepartmentWelcome from './roles/DepartmentWelcome.vue';
import OrganizationWelcome from './roles/OrganizationWelcome.vue';
import MemberWelcomeVcht from './roles/MemberWelcomeVcht.vue';
import OrganizationWelcomeVcht from './roles/OrganizationWelcomeVcht.vue';
import { DIALOG_PORTAL_KEY } from './constants';
import { ROLES } from '@/constants/roles';

const WELCOME_COMPONENT_MAP = {
  [ROLES.member]: MemberWelcome,
  [ROLES.certificate]: MemberWelcome,
  [ROLES.operator]: OperatorWelcome,
  [ROLES.department]: DepartmentWelcome,
  [ROLES.organization]: OrganizationWelcome,
};

const WELCOME_COMPONENT_MAP_VCHT = {
  [ROLES.member]: MemberWelcomeVcht,
  [ROLES.certificate]: MemberWelcomeVcht,
  [ROLES.operator]: OperatorWelcome,
  [ROLES.department]: DepartmentWelcome,
  [ROLES.organization]: OrganizationWelcomeVcht,
};

export default {
  name: 'WelcomeDialog',
  components: {
    MemberWelcome,
    OperatorWelcome,
    DepartmentWelcome,
    OrganizationWelcome,
    MemberWelcomeVcht,
    OrganizationWelcomeVcht,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      hideWelcomeDialogFor: 'auth/getHideWelcomeDialogFor',
    }),
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    welcomeComponent() {
      const componentMap = this.$conf.isVcht ? WELCOME_COMPONENT_MAP_VCHT : WELCOME_COMPONENT_MAP;

      return componentMap[this.$user.role.name];
    },
    hasAccess() {
      if (this.$conf.isVcht) {
        return !this.$user.hasRoles([this.$conf.ROLES.organization, this.$conf.ROLES.member]);
      }

      return true;
    },
    isHideByUser() {
      return !!this.hideWelcomeDialogFor.includes(this.$user?.data?.id);
    },
  },
  watch: {
    isAuthenticated(value) {
      if (value && !this.isHideByUser && this.welcomeComponent) {
        // ! @FIX temporary for member and certificate
        const NOT_ALLOWED_ROLES = [ROLES.member, ROLES.certificate];

        if (!NOT_ALLOWED_ROLES.includes(this.$user.role.name)) {
          this.openDialog();
        }
      }
    },
  },
  created() {
    if (this.isAuthenticated && !this.isHideByUser && this.welcomeComponent) {
      this.openDialog();
    }
  },
  methods: {
    ...mapActions({
      hideWelcomeDialogForUser: 'auth/hideWelcomeDialogForUser',
    }),
    openDialog() {
      // this.$dialogs.portal({
      //   attrs: {
      //     'max-width': 800,
      //     title: 'Добро пожаловать в АИС управление мероприятиями!',
      //     inputValue: DIALOG_PORTAL_KEY,
      //     persistent: true,
      //     scrollable: false,
      //   },
      // });
    },
    onHideNextTime(userId) {
      this.hideWelcomeDialogForUser(userId);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .link {
  & {
    color: #{$redesignPrimaryDarken} !important;
    font-weight: 500;
  }
}
::v-deep .list {
  & {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 16px;
  }

  &--gap-sm {
    gap: 16px;
  }
}
</style>
